import { useMutation } from '@tanstack/react-query';
import { PaymentsService } from '../services';

export const useDownloadACHAuthorizationRecord = (options = {}) => {
  const { onError } = options;

  const mutation = useMutation({
    mutationFn: async (bankId) => {
      await PaymentsService.downloadACHAuthorizationRecord(bankId);
    },
    onError: (error) => {
      if (onError) {
        onError(error);
      }
    },
  });

  return mutation;
};
